import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import {
    Container,
} from 'reactstrap'

import Form from './components/Form'
import ApiService from '../../data/services/ApiService'
import { GeneralContext } from '../../context/'
import { withRouter } from 'react-router-dom'

const Edit = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading, setBreadcrumb } = generalContext

    const { id } = useParams()
    const [data, setData] = useState([])

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Usuarios`,
            parentLink: '/users',
            item: `Editar usuario`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        (async () => {
            setLoading(true)

            try {
                const response = await ApiService.getUserById(id)
                setData(response.data.user)
            } catch (error) {
                
            } finally {
                setLoading(false)
            }
        })()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Form data={data} {...props} />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Edit)